import React from 'react';
import { ModalProps } from '@/Types';
import styles from './SelectWarehouseModal.scss';
import { Modal } from '@/Components/Modal/Modal';
import { Button } from '@/Components/Controls/Button/Button';
import { BUTTON_THEMES } from '@/Components/Controls/Button/ButtonThemes';
import { useLocalization } from '@/Hooks';
import { Label } from '@/Components/Controls/Label/Label';
import { FormSelectInput } from '@/Components/Controls/SelectInput/FormSelectInput';
import { useSelectWarehouseForm, FormData } from './hooks/useSelectWarehouseForm';
import { useSelectWarehouseOptions } from './hooks/useSelectWarehouseOptions';
import { ButtonsWrapper } from '@/Components/Forms/ButtonsSection/ButtonsSection';

type Props = {
  isSales: boolean;
} & ModalProps;

export const SelectWarehouseModal = ({ isSales, closeModalWindow }: Props) => {
  const {
    buttons: { Cancel, Next },
    modalWindows: {
      addressValidationResolving: {
        SelectWarehouseModal: { Title, Text, Warehouse },
      },
    },
  } = useLocalization();

  const { warehouseOptions, orderWarehouseInfos } = useSelectWarehouseOptions(isSales);

  const {
    rules: { required },
    methods: { register, onSubmit },
  } = useSelectWarehouseForm(orderWarehouseInfos);

  if (warehouseOptions.length === 0) return null;

  return (
    <Modal
      modalClassName={styles.modal}
      onClose={closeModalWindow}
      shouldCloseOnOverlayClick={false}
      description={{
        title: Title,
        text: Text,
      }}
    >
      <form onSubmit={onSubmit} className={styles.form}>
        <Label text={Warehouse} className={styles.formLabel} />
        <FormSelectInput<FormData>
          name={'warehouseId'}
          options={warehouseOptions}
          register={register}
          needClearButton={false}
          rules={required}
        />

        <ButtonsWrapper>
          <Button theme={BUTTON_THEMES.SUCCESS_TRANSPARENT} text={Cancel} onClick={closeModalWindow} />
          <Button type={'submit'} autoFocus={true} theme={BUTTON_THEMES.SUCCESS} text={Next} />
        </ButtonsWrapper>
      </form>
    </Modal>
  );
};
